// Styles
import { SummaryBarDetails_s } from 'components/wrapper/wrapper-styles';
import { local } from 'data/lib/local-json';
// Data
import { localizeNum } from "data/lib/numbers";
import propertyService from 'data/property';
import socketService, * as eventType from "data/socket";
import _ from 'lodash';
import React, { FC, useEffect, useState } from 'react';

const SummaryBar: FC = (props) => {
  const [summary, setSummary] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState<number|null>(local('property'))
  const [propertyType, setPropertyType] = useState<string|null>(local('property_type'))

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        const currentProperty = _.find(data.value, {propertyid: data.current});
        currentProperty && setPropertyId(currentProperty['propertyid'])
        currentProperty && setPropertyType(currentProperty['type'])
      }
    });

    const socketSubscription = socketService.stream().subscribe(data => {
      switch(true) {
        case data.eventType === eventType.CALC_FINISHED:
          propertyId && propertyService.fetchSummary(propertyId).then(summary => setSummary(summary['propertySummaryBar']))
          break
      }
    })

    return function cleanup() {
      propertySubscription.unsubscribe()
      socketSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    propertyId && propertyService.fetchSummary(propertyId).then(summary => setSummary(summary['propertySummaryBar']))
  }, [propertyId])

  return (
    <SummaryBarDetails_s id="summary-bar-details">
      <div>
        <label>Valuation Scenario Name</label>
        <span>{summary?.['valuationDescription']}</span>
      </div>
      <div>
        <label>Property Value</label>
        {summary?.['lastCalcValue'] && <span>{`$${localizeNum(summary?.['lastCalcValue'], 0)}`}</span>}
      </div>
      <div>
        <label>Terminal Cap Rate</label>
        <span>{summary?.['terminalCap'] && `${localizeNum(summary?.['terminalCap'], 2)}%`}</span>
      </div>
      <div>
        <label>Discount Rate</label>
        <span>{summary?.['terminalCap'] && `${localizeNum(summary?.['discountRate'], 2)}%`}</span>
      </div>
      <div>
        <label>Yr 1 Occupancy</label>
        <span>{summary?.['year1Occupancy'] && `${localizeNum(summary?.['year1Occupancy']*100, 2)}%`}</span>
      </div>
      <div>
        <label>Property Area</label>
        <span>{localizeNum(summary?.['calcArea'])}</span>
      </div>
      { propertyType !== 'Multifamily' && propertyType !== 'Hospitality' && <div>
        <label>Weighted Avg Lease Term</label>
        {summary?.['weightedLeaseTermMonths'] && <span>{localizeNum(summary?.['weightedLeaseTermMonths']/12, 2)} Years</span>}
      </div> }
    </SummaryBarDetails_s>
  )
}

export default SummaryBar
